import { createPortal } from "react-dom";
import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

import { useIsMounted } from "shared/lib/hooks";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  return createPortal(
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group shadcn-toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.shadcn-toast]:text-muted-foreground",
          actionButton:
            "group-[.shadcn-toast]:bg-primary group-[.shadcn-toast]:text-primary-foreground",
          cancelButton:
            "group-[.shadcn-toast]:bg-muted group-[.shadcn-toast]:text-muted-foreground",
        },
      }}
      {...props}
    />,
    document.body
  );
};

export { Toaster, toast };
